import { useNavigate } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";

export default function ProjectCard({ project }) {
  const { id, title, status, statusColor, tag, centre, eta, stage, progress } = project;
  const navigate = useNavigate();

  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-5">
      <div className="flex items-center justify-between mb-4">
        <span className="text-xs font-mono font-medium px-3 py-1 rounded-full bg-white border border-gray-300 text-gray-700">
          {id}
        </span>
        <span className={`text-xs font-semibold px-3 py-1 rounded-full ${statusColor}`}>
          {status}
        </span>
      </div>

      <h3 className="font-bold text-gray-900 text-lg mb-1">{title}</h3>
      <p className="text-sm text-gray-500 mb-4">
        {tag} · {centre}
      </p>

      <div className="flex items-center justify-between text-sm mb-1.5">
        <span className="text-gray-600">{stage}</span>
        <span className="font-bold text-gray-900">{progress}%</span>
      </div>
      <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden mb-4">
        <div
          className="h-full bg-[#0f1229] rounded-full"
          style={{ width: `${progress}%` }}
        />
      </div>

      <div className="flex items-center justify-between">
        <span className="flex items-center gap-1.5 text-sm text-gray-500">
          <Clock className="w-3.5 h-3.5" />
          ETA {eta}
        </span>
        <button
          type="button"
          onClick={() => navigate(`/app/projects/${id}`)}
          className="flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-700"
        >
          Open workspace
          <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}